import { combineReducers } from 'redux';
import tokenFlagReducer from './tokenFlag.reducer';

export default combineReducers({
  tokenFlag: tokenFlagReducer,
});
